import request from './request.js';
import {requestbody} from './request.js'

//工作底稿分页查询
export async function workManuscriptPage (params = {}) {
	return await request('/work-manuscript/page', 'get', params)
}

//生成工作底稿
export async function generateWorkManuscript (params = {}) {
	return await request('/work-manuscript/generateWorkManuscript', 'post', params)
}

//计算底稿
export async function calculationManuscript (params = {}) {
	return await request('/manuscript/calculationManuscript', 'post', params)
}

//查看底稿
export async function selectManuscriptContent (params = {}) {
	return await request('/manuscript-content/selectManuscriptContent', 'get', params)
}

//工作底稿修改
export async function workManuscriptUpdate (params = {}) {
	return await request('/work-manuscript/updateStatus', 'post', params)
}

//工作底稿内容修改
export async function manuscriptContentUpdate (params = {}) {
	return await request('/manuscript-content/update', 'post', params)
}

//工作底稿内容修改
export async function getFlowCenter (params = {}) {
	return await request('/oa/flowCenter/getFlowCenter', 'get', params)
}

//生成工作底稿
export async function generateManuscript (params = {}) {
	return await request('/manuscript/generateManuscript', 'post', params)
}

//金蝶接收余额数据
export async function syncReceiveBalanceData (params = {}) {
	return await request('/receiveBalanceData/syncReceiveBalanceData', 'post', params)
}

//金蝶接收余额数据
export async function syncEsaDataByCompany (params = {}) {
	return await request('/receiveBalanceData/syncEsaDataByCompany', 'post', params)
}

//下载工作底稿
export async function downloadWorkManuscript (params = {}) {
	return await request('/manuscript-content/exportWorkManuscript', 'post', params)
}

//根据企业code获取六税两费信息
export async function queryCcxwsPolicy (params = {}) {
	return await request('/manuscript/queryCcxwsPolicy', 'get', params)
}

//删除批次数据
export async function delBatchData (params = {}) {
	return await request('/contract/delBatchData', 'post', params)
}
//查询所有公司
export async function queryAllCompanys (params = {}) {
	return await requestbody('sys/getAllCompanys', 'post', params)
}

//同步人员信息
export async function syncUser (params = {}) {
	return await request('/auth/syncUser', 'post', params)
}
